import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./CreditDetails.css";
import { Api } from "../Api/Api";

export const WorkerCreditDetails = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editPaidAmount, setEditPaidAmount] = useState("");

  useEffect(() => {
    fetchOrders();
  }, []);

  // Fetch credit orders from backend
  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${Api}bills/get_all.php`);

      // ✅ Only Credit orders that are NOT cleared
      const creditOrders = res.data.filter(
        (order) =>
          order.payment_type &&
          order.payment_type.toLowerCase().trim() === "credit" &&
          parseInt(order.isCleared) === 0
      );

      setOrders(creditOrders);
      console.log("Credit Orders (not cleared):", creditOrders);
    } catch (err) {
      console.error("Error fetching credit orders:", err);
    }
  };

  // ✅ Handle Edit Save
  const handleSaveEdit = async (order) => {
    try {
      const res = await axios.post(`${Api}bills/bills_update.php`, {
        id: order.id,
        paid: editPaidAmount,
      });

      if (res.data.status === "success") {
        setOrders((prevOrders) =>
          prevOrders.map((o) =>
            o.id === order.id
              ? { ...o, paid: res.data.paid, balance: res.data.balance }
              : o
          )
        );
        Swal.fire("Updated!", "Paid amount updated successfully.", "success");
        setEditingId(null);
      } else {
        Swal.fire("Error!", res.data.message, "error");
      }
    } catch (err) {
      console.error("Error updating payment:", err);
      Swal.fire("Error!", "Failed to update payment.", "error");
    }
  };

  // ✅ Mark payment as cleared

  // ✅ Mark payment as cleared
  const handlePaymentCleared = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to mark this payment as cleared?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clear it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(`${Api}bills/bills_clear.php`, { id });

          if (res.data.status === "success") {
            // ✅ Update paid & balance in UI
            setOrders((prevOrders) =>
              prevOrders.map((order) =>
                order.id === id
                  ? {
                      ...order,
                      paid: res.data.paid,
                      balance: res.data.balance,
                      isCleared: 1,
                    }
                  : order
              )
            );

            Swal.fire("Cleared!", "The payment has been cleared.", "success");
          } else {
            Swal.fire("Error!", res.data.message, "error");
          }
        } catch (err) {
          console.error("Error clearing payment:", err);
          Swal.fire("Error!", "Failed to clear payment.", "error");
        }
      }
    });
  };

  // ✅ Filter orders by invoice no or worker name
  const filteredOrders = orders
    .filter((order) => {
      if (!searchTerm) return true;
      const search = searchTerm.toLowerCase();
      return (
        order.invoice_no?.toLowerCase().includes(search) ||
        order.worker_name?.toLowerCase().includes(search)
      );
    })
    .sort((a, b) => {
      const aMatch =
        a.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        a.worker_name?.toLowerCase().includes(searchTerm.toLowerCase());
      const bMatch =
        b.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        b.worker_name?.toLowerCase().includes(searchTerm.toLowerCase());
      return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
    });

  return (
    <div className="credit-container">
      <h2>Credit Orders (Pending)</h2>

      {/* Search box */}
      <input
        type="text"
        placeholder="Search by Invoice No or Worker Name"
        className="search-box"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {filteredOrders.length === 0 ? (
        <p>No pending credit orders found.</p>
      ) : (
        <table className="main-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Invoice No</th>
              <th>Worker Name</th>
              <th>Items</th>
              <th>Subtotal</th>
              <th>Total</th>
              <th>Paid</th>
              <th>Balance</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map((order, index) => (
              <tr key={order.id}>
                <td>{index + 1}</td>
                <td>{order.invoice_no}</td>
                <td>{order.worker_name}</td>
                <td>
                  <table className="nested-table">
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.items.map((item, i) => (
                        <tr key={i}>
                          <td>{item.product}</td>
                          <td>{item.quantity}</td>
                          <td>₹{item.price}</td>
                          <td>₹{item.quantity * parseFloat(item.price)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
                <td>₹{order.subtotal}</td>
                <td>₹{order.total}</td>

                {/* ✅ Editable Paid */}
                <td>
                  {editingId === order.id ? (
                    <input
                      type="number"
                      value={editPaidAmount}
                      onChange={(e) => setEditPaidAmount(e.target.value)}
                    />
                  ) : (
                    `₹${order.paid}`
                  )}
                </td>

                {/* ✅ Balance */}
                <td>₹{order.balance}</td>

                {/* ✅ Action Buttons */}
                <td>
                  {editingId === order.id ? (
                    <div className="action-buttons">
                      <button
                        className="save-btn"
                        onClick={() => handleSaveEdit(order)}
                      >
                        Save
                      </button>
                      <button
                        className="cancel-btn"
                        onClick={() => setEditingId(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="action-buttons">
                      <button
                        className="edit-btn"
                        onClick={() => {
                          setEditingId(order.id);
                          setEditPaidAmount(order.paid);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="clear-btn"
                        onClick={() => handlePaymentCleared(order.id)}
                      >
                        Payment Cleared
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
